import "./index.css";
import Portfolio from "./panele/Portfolio";
import Ikonki from "./panele/Ikonki";
import CallMe from "./panele/CallMe";
import News from "./panele/News";
import { motion } from "framer-motion";

function Home(props) {
  return (
    <motion.div
      id="everything"
      style={{ backgroundColor: "#333d1d" }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Ikonki />
      <News content={props.content} />
      <Portfolio />
      <CallMe />
    </motion.div>
  );
}

export default Home;
